import React from "react";
import { X, Cookie } from "lucide-react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const seen = localStorage.getItem("fdl_cookie_ok");
    if (!seen) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("fdl_cookie_ok", "1");
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl rounded-2xl border border-border bg-card/95 p-4 shadow-xl shadow-black/50 backdrop-blur-md">
      <div className="flex items-start gap-3">
        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary text-[#4aa4ff]">
          <Cookie className="h-4 w-4" />
        </span>
        <div className="flex-1 text-sm text-muted-foreground">
          We use one essential cookie to keep you signed in, plus Stripe’s cookies during checkout. No ad-tech, no tracking. See our{" "}
          <Link to="/privacy" className="text-[#4aa4ff] hover:underline">Privacy Policy</Link>.
        </div>
        <button onClick={accept} className="rounded-lg bg-[#4aa4ff] px-3 py-1.5 text-xs font-semibold text-[#05070d] hover:brightness-105">Got it</button>
        <button onClick={accept} aria-label="Dismiss" className="ml-1 text-muted-foreground hover:text-foreground">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
